"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagNameInputController = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var modal_service_1 = require("../../components/modal/modal.service");
var i18n_1 = require("../../i18n");
var services_1 = require("../../services");
var page_state_1 = require("../../state/page.state");
var store_1 = require("../../store");
var tag_name_input_confirmation_1 = require("./tag.name.input.confirmation");
var TagNameInputController = /** @class */ (function () {
    function TagNameInputController(tagState, tag) {
        this.tagState = tagState;
        this.editState = tagState.edit;
        this.tag = tag;
    }
    TagNameInputController.prototype.getInputState = function () {
        return this.editState.input;
    };
    TagNameInputController.prototype.getInputValue = function () {
        return this.editState.input.value;
    };
    TagNameInputController.prototype.getTagFilterValue = function () {
        return services_1.Services.Search.filterState.filter;
    };
    TagNameInputController.prototype.zoomToTag = function () {
        this.tagState.map.zoomToTag(this.tag.objectId);
        if (page_state_1.CurrentState.expandedTagId === this.tag.objectId) {
            this.tagState.collapseTag(this.tag);
        }
        else {
            this.tagState.expandTag(this.tag);
        }
    };
    TagNameInputController.prototype.updateEdit = function (value) {
        this.editState.input.setTouched();
        this.editState.input.setValue(value);
    };
    TagNameInputController.prototype.acceptEdit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var name, cleanName, tagSummary, isMerge, modelResponse, collections, updatedTag;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        name = this.editState.input.value;
                        if (name == null) {
                            this.cancelEdit();
                            return [2 /*return*/, Promise.resolve()];
                        }
                        cleanName = name.trim();
                        if (cleanName.length === 0 || cleanName === this.tag.name) {
                            this.cancelEdit();
                            return [2 /*return*/, Promise.resolve()];
                        }
                        tagSummary = store_1.AppStore.TagSummary.get(this.tag.objectId);
                        if (tagSummary == null) {
                            services_1.Logger.error("Cannot rename tag '".concat(this.tag.name, "' before tag summary retrieved."));
                            return [2 /*return*/, Promise.resolve()];
                        }
                        // Make sure this tag is not selected if we are renaming it.
                        page_state_1.CurrentState.Tag.selectTag(this.tag.objectId, false);
                        isMerge = this.tagState.tags.some(function (t) { return t.name === name; });
                        return [4 /*yield*/, this.showRenameModal(isMerge, tagSummary.revisions.length, name)];
                    case 1:
                        modelResponse = _a.sent();
                        this.cancelEdit();
                        if (modelResponse.cancel) {
                            return [2 /*return*/];
                        }
                        this.editState.setRenaming(this.tag.objectId);
                        if (!isMerge) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.getCollections(tagSummary)];
                    case 2:
                        collections = _a.sent();
                        return [4 /*yield*/, services_1.Services.Collection.move(collections, name)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, services_1.Services.Tag.rename(this.tag.objectId, name)];
                    case 5:
                        _a.sent();
                        updatedTag = store_1.AppStore.Tag.get(this.tag.objectId);
                        if (updatedTag && updatedTag !== this.tag) {
                            this.tag = updatedTag;
                        }
                        _a.label = 6;
                    case 6:
                        page_state_1.CurrentState.clearSelected();
                        this.editState.cancelRenaming();
                        return [2 /*return*/];
                }
            });
        });
    };
    TagNameInputController.prototype.cancelEdit = function () {
        this.editState.setTagId(null);
        this.editState.input.reset();
        if (this._tagCard) {
            services_1.Services.FocusAway.dropByElement(this._tagCard);
        }
    };
    Object.defineProperty(TagNameInputController.prototype, "autoCompleteOptions", {
        get: function () {
            var _this = this;
            return this.tagState.tags
                .filter(function (tag) { return tag.objectId !== _this.tag.objectId; })
                .map(function (tag) { return ({ id: tag.objectId, value: tag.name }); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TagNameInputController.prototype, "tagCard", {
        set: function (tagCard) {
            this._tagCard = tagCard;
        },
        enumerable: false,
        configurable: true
    });
    TagNameInputController.prototype.showRenameModal = function (merge, collectionCount, newName) {
        if (merge) {
            return modal_service_1.ModalService.open({
                title: (0, i18n_1.Translate)(i18n_1.T.TAG_MERGE_TITLE),
                content: tag_name_input_confirmation_1.TagNameInputConfirmationContent.view(collectionCount, this.tag.name, newName),
                hasCancel: TagNameInputController.CAN_CANCEL_RENAME
            });
        }
        return Promise.resolve({ ok: true, cancel: false });
    };
    TagNameInputController.prototype.getCollections = function (tagSummary) {
        var collections = [];
        for (var _i = 0, _a = tagSummary.revisions; _i < _a.length; _i++) {
            var revision = _a[_i];
            var collectionSummary = store_1.AppStore.CollectionSummary.get(revision);
            if (collectionSummary != null) {
                collections.push(Promise.resolve(collectionSummary));
            }
            else {
                collections.push(store_1.AppStore.CollectionSummary.fetch(revision));
            }
        }
        return Promise.all(collections);
    };
    TagNameInputController.CAN_CANCEL_RENAME = true;
    tslib_1.__decorate([
        mobx_1.action
    ], TagNameInputController.prototype, "updateEdit", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TagNameInputController.prototype, "cancelEdit", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], TagNameInputController.prototype, "autoCompleteOptions", null);
    return TagNameInputController;
}());
exports.TagNameInputController = TagNameInputController;
//# sourceMappingURL=tag.name.input.ctrl.js.map